/**
 * Toont de gekozen bestandsnamen bij een file-veld waarvan de native input
 * verborgen is. De browsertekst ("No file chosen") valt daarmee weg, dus die
 * info moeten we zelf terugzetten, met per bestand een knopje om het weer uit
 * de selectie te halen.
 *
 * Werkt met delegatie op document, zodat het ook blijft werken voor velden die
 * later in de DOM komen (Formie hertekent het formulier bij een ajax-submit).
 */

// Een FileList is read-only, dus een nieuwe samenstellen zonder dit bestand
const removeFile = (input, fileToRemove) => {
    const files = new DataTransfer()

    Array.from(input.files).forEach((file) => {
        if (file !== fileToRemove) {
            files.items.add(file)
        }
    })

    input.files = files.files

    // Onze eigen listener tekent de lijst opnieuw, Formie hervalideert het veld
    input.dispatchEvent(new Event('change', { bubbles: true }))
}

const renderFiles = (wrapper, input) => {
    const output = wrapper.querySelector('[data-file-upload-files]')
    const template = wrapper.querySelector('[data-file-upload-item]')

    if (!output) return

    output.textContent = ''

    Array.from(input.files).forEach((file) => {
        if (!template) {
            output.append(file.name)
            return
        }

        const item = template.content.firstElementChild.cloneNode(true)
        const name = item.querySelector('[data-file-upload-name]')
        const remove = item.querySelector('[data-file-upload-remove]')

        if (name) {
            name.textContent = file.name
        }

        if (remove) {
            const label = remove.dataset.removeLabel

            if (label) {
                remove.setAttribute('aria-label', `${label} ${file.name}`)
            }

            remove.addEventListener('click', () => removeFile(input, file))
        }

        output.appendChild(item)
    })
}

export const initFileUpload = () => {
    document.addEventListener('change', (event) => {
        const input = event.target

        if (!(input instanceof HTMLInputElement) || input.type !== 'file') {
            return
        }

        const wrapper = input.closest('[data-file-upload]')

        if (wrapper) {
            renderFiles(wrapper, input)
        }
    })
}
